import {  useState } from "react";
import { CollectCard } from "./Cards";

const sampleData=[{
    value:
    {
        price:"see more.....",
        image: "/img/NFT001.png",
        name: "Buho Estudiante",
        description: "Buho description",
    }},
    {value:
    {
        price:"see more.....",
        image: "/img/NFT002.png",
        name: "Buho Graduado",
        description: "Buho description",
    }},
    {value:
        {
            price:"see more.....",
            image: "/img/NFT003.png",
            name: "Buho Nadador",
            description: "Buho description",
    }},
    {value:
        {
            price:"see more.....",
            image: "/img/NFT004.png",
            name: "Buho Nadador",
            description: "Buho description",
    }},
    {value:
        {
            price:"see more.....",
            image: "/img/NFT005.png",
            name: "Buho Nadador",
            description: "Buho description",
    }},
    {value:
        {
            price:"see more.....",
            image: "/img/NFT006.png",
            name: "Buho Nadador",
            description: "Buho description",
    }},
    {value:
        {
            price:"see more.....",
            image: "/img/NFT007.png",
            name: "Buho Nadador",
            description: "Buho description",
    }},
    {value:
        {
            price:"see more.....",
            image: "/img/NFT008.png",
            name: "Buho Nadador",
            description: "Buho description",
    }},
    {value:
        {
            price:"see more.....",
            image: "/img/NFT009.png",
            name: "Buho Nadador",
            description: "Buho description",
    }}
]

export function CollectionsHome() {
    const [data, updateData] = useState(()=>sampleData);
    const [filter,setFilter]=useState("all")

    const handleFilter=(e)=>{
        const value=e.target.value
        const cards=value=="1"||value==="all"?sampleData:[]
        updateData(cards)
        setFilter(value)
    }   

    return (
        <section className="collections" id="collections">
                <div className="container">
                    <h1 className="bold size6 ta-center titlegreen">Colecciones</h1>
                    <p className="spacebottom3 halfwhite size2 ta-center">
                        Visualiza nuestra gran colección de NFT<br />que tenemos para ti
                    </p>
                    <div className="row spacebottom3 filter-buttons justify-between">
                        <button onClick={handleFilter} className={`${filter==="all"?"text-green-600":""} col3 filter col6-xs spacebottom1-xs`} data-filter="all" value={"all"}>Todo</button>
                        <button onClick={handleFilter} className={`${filter==="1"?"text-green-600":""} col3 filter col6-xs spacebottom1-xs`} data-filter="art" value={1}>1° Edicion</button>
                        <button onClick={handleFilter} className={`${filter==="2"?"text-green-600":""} col3 filter col6-xs`} data-filter="photograpy" value={2}>2° Edicion</button>
                        <button onClick={handleFilter} className={`${filter==="3"?"text-green-600":""} col3 filter col6-xs`} data-filter="pattern" value={3}>3° Edicion</button>
                    </div>
                    <CollectCard data={data} loading={false}/>
                </div>
            </section>
    )
}